//@flow
import * as actionTypes from './actionTypes';
import {
    submitTaskApi,getTaskApi,getVendorsApi
} from '../../apiUtils/api';
import { transformDataToEditFormData } from './editFormData'
import { getReviewOutcome } from '../demeter/submitFormData'
import type { Dispatch$Type,ReducerState$Type,EditForm$Type,PostForm$Type } from '../genericFlowTypes'

const workflowType = 'Orion'

export const getTaskData=(orion:ReducerState$Type, jwt:string,taskAcceptedInfoId: number)=>{
    return (dispatch:Dispatch$Type) => getTaskApi(jwt,workflowType,taskAcceptedInfoId.toString())
    .then((res)=>res.json()).then((data)=>{
        const error = (data.error:any|null)
        if (error){
            dispatch({type: actionTypes.ORION_EDIT_VERIFY_FORM_DATA_ERROR,error: error});
        }else {
            const formData = transformDataToEditFormData(data,orion)
            dispatch({
                type: actionTypes.ORION_EDIT_VERIFY_FORM_DATA_SUCCESS, 
                formData: formData,reviewQuestions: data['reviewQuestions'] });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.ORION_EDIT_VERIFY_FORM_DATA_ERROR, error: err});
    })
}

export const invoiceSubmissionCompleted = () => {
    return { type: actionTypes.ORION_INV_SUBMITTED_COMPLETED };
}

export const invoiceSubmission = (jwt:any,taskAcceptedInfoId:number,orionResultset:any,orion:ReducerState$Type)=>{
    let payload:PostForm$Type={
        taskAcceptedInfoId:taskAcceptedInfoId
    };

    if (orionResultset.isInvalidDoc){
        payload.isInvalidDoc=true;
    }else {
        payload.vendorName=orionResultset.vendorName;
        payload.invNo=orionResultset.invNo;
        payload.invDate=orionResultset.invDate;
        payload.poNo=orionResultset.poNo;
        payload.location=orionResultset.location;
        payload.total=orionResultset.total;
        payload.isInvalidDoc=orionResultset.isInvalidDoc?orionResultset.isInvalidDoc:false;
        payload.isOverrideTotal=orionResultset.isOverrideTotal?orionResultset.isOverrideTotal:false;
        payload.isOverrideVendorName=orionResultset.isOverrideVendorName?orionResultset.isOverrideVendorName:false;
    }

    if (orion.reviewQuestions && orion.reviewQuestions.length > 0){
        payload.reviewOutcome=getReviewOutcome(orionResultset,orion.reviewQuestions)
    }
    
    return (dispatch:Dispatch$Type) => submitTaskApi(jwt,payload).then((res)=>res.json()).then((data) =>{
        if (data['error']){
            dispatch({type: actionTypes.ORION_INV_SUBMIT_ERROR, error: data.error});
        }else {
            dispatch({type: actionTypes.ORION_INV_SUBMIT_SUCCESS});
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.ORION_INV_SUBMIT_ERROR, error: err});
    })
}

export const updateFormError=(error:any|null)=>{
    return { type: actionTypes.ORION_UPDATE_FORM_ERROR, formError: error }
}

export const populateVendorsList=(jwt:any)=>{
    return (dispatch:Dispatch$Type) => getVendorsApi(jwt,workflowType).then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.REFRESH_ORION_VENDORS_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.REFRESH_ORION_VENDORS_SUCCESS, vendors: data.vendors });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.REFRESH_ORION_VENDORS_ERROR, error: err});
    })
}



// WEBPACK FOOTER //
// ./src/redux/orion/actions.js